module.exports = __webpack_public_path__ + "img/28.8ea8f9cc.jpg";